<template>
    <div class="hello">

        <v-container fluid class="grey-container cta-container" :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#E6E6E6', 'background-image': 'url(' + getBackground + ')' }">
                <v-card
                        v-if="show"
                        width="600"
                        class="mx-auto mt-12 product-card"
                        outlined
                        :elevation="hover ? 4 : 0"
                >
                    <v-card-title>
                        <h1 class="headline primary--text">{{product.name}}</h1>
                    </v-card-title>

                    <v-carousel
                            v-if="product.product_images.length > 1"
                            cycle
                            continuous
                            show-arrows
                            hide-delimiters
                            height="300px">
                        <v-carousel-item
                                v-for="(item, i) in product.product_images"
                                :key="i"
                        >
                            <v-img
                                    v-if="item.path"
                                    class="white--text align-end"
                                    height="300px"
                                    :src="item.path"
                            >
                                <v-overlay
                                        v-if="product.coming_soon"
                                        :absolute="true"
                                        :value="true"
                                        :opacity="0.5"
                                >
                                    <p class="title white--text"><v-icon left large dark color="white">mdi-bullhorn</v-icon> {{ $t("Coming soon") }}</p>
                                </v-overlay>
                            </v-img>
                        </v-carousel-item>
                    </v-carousel>

                    <v-img
                            v-if="product.product_images.length === 1"
                            class="white--text align-end"
                            height="300px"
                            :src="product.product_images[0].path"
                    >
                        <v-overlay
                                v-if="product.coming_soon"
                                :absolute="true"
                                :value="true"
                                :opacity="0.5"
                        >
                            <p class="title white--text"><v-icon left large dark color="white">mdi-bullhorn</v-icon> {{ $t("Coming soon") }}</p>
                        </v-overlay>
                    </v-img>
                    <v-card
                            v-if="product.product_images.length === 0"
                            :color="`grey lighten-4`"
                            class="px-3 pt-3 pb-3"
                            flat
                            tile
                    >
                        <v-skeleton-loader
                                class="mx-auto"
                                height="176"
                                type="image"
                        ></v-skeleton-loader>
                        <v-overlay
                                :absolute="true"
                                :value="true"
                                :opacity="0"
                        >
                            <p class="title black--text"><v-icon left large color="black">mdi-bullhorn</v-icon> {{ $t("Image coming soon") }}</p>
                        </v-overlay>
                    </v-card>

                    <v-card-text>

                        <p class="font-weight-black subtitle-1" v-if="product.enabled">{{ brand === 'neotag' ? '€' : '£'}}{{product.price}}</p>

                        <div class="body-1 mb-6">{{product.description}}</div>

                        <h3 class="subtitle-2 mb-3" v-if="keyPoints.length > 0">{{ $t('headings.Key points') }}</h3>

                        <ul class="mb-6">
                            <li v-for="(point, i) in keyPoints"
                                :key="i">{{point}}</li>
                        </ul>

                        <h3 class="subtitle-2 mb-3" v-if="delivery.length > 0">{{ $t('headings.Delivery') }}</h3>

                        <ul class="mb-6">
                            <li v-for="(row, i) in delivery"
                                :key="i">{{row}}</li>
                        </ul>

                        <h3 class="subtitle-2 mb-3" v-if="returns.length > 0">{{ $t('headings.Returns') }}</h3>

                        <ul class="mb-6">
                            <li v-for="(row, i) in returns"
                                :key="i">{{row}}</li>
                        </ul>

                        <h3 class="subtitle-2 mb-3" v-if="environmental.length > 0">{{ $t('headings.Environmental credentials') }}</h3>

                        <ul class="mb-6">
                            <li v-for="(row, i) in environmental"
                                :key="i">{{row}}</li>
                        </ul>

                        <h3 class="subtitle-2 mb-3" v-if="hints > 0">{{ $t('headings.Hints and tips') }}</h3>

                        <ul class="mb-6">
                            <li v-for="(row, i) in hints"
                                :key="i">{{row}}</li>
                        </ul>

                    </v-card-text>

                    <v-card-actions class="d-flex justify-space-between align-end" style="width: 100%">
                        <v-btn v-if="product.coming_soon" disabled class="ml-2 small" elevation="0" tile color="primary" @click="addToBasket(product)">
                            <v-icon left>add_shopping_cart</v-icon> {{ $t("Coming soon") }}
                        </v-btn>
                        <v-btn v-else class="ml-2 small" elevation="0" tile color="primary" @click="addToBasket(product)">
                            <v-icon left>add_shopping_cart</v-icon> {{ $t('buttons.Add to basket') }}
                        </v-btn>
                        <router-link
                                :to="{ name: 'activate' }"
                        >
                        <v-img
                                v-if="product.activate == 1"
                                class="white--text"
                                max-width="80px"
                                :src="activ8Logo"
                                eager
                        >
                        </v-img>
                        </router-link>
                    </v-card-actions>

                    <v-card-text>

                        <v-divider class="mb-6" v-if="videoID"></v-divider>

                        <h3 v-if="videoID" class="subtitle-2 mb-3">
                            <span v-if="[1,3,8,13].includes(product.id)">{{ $t('headings.How to iron on tags') }}</span>
                            <span v-else-if="product.id === 28">{{ $t('headings.How the ID bracelet works') }}</span>
                            <span v-else-if="product.activate">{{ $t('headings.How to activate tags') }}</span>
                            <span v-else-if="product.id === 10">{{ $t('headings.Our service for organisations') }}</span>
                        </h3>

                        <vimeo-player v-if="videoID" ref="player" :video-id="videoID" @ready="onReady" class="player-container" :options="options"></vimeo-player>

                        <v-divider class="mb-6"></v-divider>

                        <v-btn text icon color="primary" @click="navigate('products')">
                            <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>

                    </v-card-text>
                </v-card>
                <v-sheet
                        v-else
                        :color="`grey lighten-4`"
                        max-width="600"
                        class="mx-auto mt-12 px-3 pt-3 pb-3"
                >
                    <v-skeleton-loader
                            class="mx-auto"
                            type="card"
                    ></v-skeleton-loader>
                </v-sheet>

                <v-dialog
                        v-model="membershipDialog"
                        width="500"
                >
                    <v-card>
                        <v-card-title class="headline primary">
                            {{ $t('headings.Membership') }}
                        </v-card-title>

                        <v-card-text>
                            <MembershipForm/>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    color="primary"
                                    text
                                    @click="membershipDialog = false"
                            >
                                {{ $t('buttons.Close') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>

                </v-dialog>
            </v-container>
        <Footer />
    </div>
</template>

<script>
    import axios from 'axios';
    import Footer from './Footer';
    import {mapActions, mapGetters, mapState} from 'vuex';
    import MembershipForm from './MembershipForm'
    import {i18n} from "../i18n";

    export default {
        name: "Product",
        metaInfo () {
            return {
                title: this.capitalizeFirstLetter(this.brand) + ' - ' + `${this.title}`,
                htmlAttrs: {
                    lang: i18n.locale
                },
                meta: [
                    { name: 'description', content: `${this.description}` }
                ]
            }
        },
        components: {
            'Footer': Footer,
            'MembershipForm': MembershipForm
        },
        props: ['slug'],
        data () {
            return {
                videoID: null,
                options: {'responsive': true, 'dnt': true},
                playerReady: false,
                product: null,
                title: '',
                description: '',
                show: false,
                hover: false,
                membershipDialog: false
            }
        },
        mounted () {

            this.$gtag.pageview({
                page_path: '/shop/' + this.slug,
            })

            document.getElementById("scrolling-content").scrollTop = 0

            this.loadProduct()
        },
        watch: {
          locale (to, from){
            if (to !== from) {
              this.loadProduct()
            }
          }
        },
        computed: {
            ...mapGetters('account', ['hasMembership', 'hasActiveTrial']),
            ...mapState({
              brand: state => state.brand,
              brandName: state => state.brandName,
              locale: state => state.locale
            }),
            getBackground() {
              if (this.brand === 'neotag') {
                return require('@/assets/neotag-background.jpg')
              }
              else {
                return require('@/assets/neotag-background.jpg')
              }
            },
            activ8Logo() {
              if (this.brand === 'neotag') {
                return require('@/assets/activ8-logo-alpha-dark.png')
              }
              return require('@/assets/activ8-logo.png')
            },
            keyPoints() {
                if (this.product.points) {
                    return this.product.points.split("\n")
                }

                return [];
            },
            delivery() {
                if (this.product.delivery) {
                    return this.product.delivery.split("\n")
                }

                return [];
            },
            returns() {
                if (this.product.returns) {
                    return this.product.returns.split("\n")
                }

                return [];
            },
            hints() {
                if (this.product.hints) {
                    return this.product.hints.split("\n")
                }

                return [];
            },
            environmental() {
                if (this.product.environmental) {
                    return this.product.environmental.split("\n")
                }

                return [];
            }
        },
        methods: {
            ...mapActions('basket', ['add']),
            loadProduct() {
              this.show = false

              const instance = axios.create({
                baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                headers: {'Accept-Language': i18n.locale},
              });

              instance
                  .get('/api/products/slug/' + this.slug + '?brand=' + this.brand )
                  .then(response => {
                    this.product = response.data.data
                    console.log(this.product)
                    this.title = response.data.data.name
                    this.description = response.data.data.description
                    if ([1,3,8,13].includes(response.data.data.id)) {
                      this.videoID = '395461762'
                    }
                    else if (this.product.id === 28) {
                      this.videoID = '536334472'
                    }
                    else if (this.product.activate) {
                      this.videoID = '396708602'
                    }
                    else if (this.product.id === 10) {
                      this.videoID = '397128650'
                    }
                  })
                  .catch(error => {
                    console.log(error)
                  })
                  .finally(() => {
                    this.show = true
                    window.prerenderReady = true;
                  })
            },
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            addToBasket(product) {
                if (this.hasMembership || this.hasActiveTrial) {
                    return this.add({product}).then(() => {
                        console.log('add')
                        this.$gtag.event('Add', {
                            'event_category': 'Shop',
                            'event_label': 'Shop add',
                            'value': product.name
                        })
                    })
                }
                else {
                    this.membershipDialog = true
                }
            },
            navigate(route) {
                this.$router.push({name: route})
            },
            onReady() {
                this.playerReady = true
            },
            play () {
                this.$refs.player.play()
            },
            stop () {
                this.$refs.player.stop()
            },
        }
    }
</script>

<style scoped>
    .product-card {
        border-radius: 15px;
        border: none !important;
    }
    .product-card .headline {
        font-size: 1.4rem !important;
    }
</style>
